<template>
  <div>
    <a-form-model ref="form" :model="form.data" :rules="form.rules">
      <a-form-model-item label="标题" prop="title">
        <a-input v-model="form.data.title"/>
      </a-form-model-item>
      <a-form-model-item label="副标题" prop="subTitle">
        <a-input v-model="form.data.subTitle"/>
      </a-form-model-item>
      <!-- <a-form-model-item label="分类" prop="type">
        <dict-select v-model="form.data.type" dict-code="INDEX_POSTER_TYPE"/>
      </a-form-model-item> -->
      <a-form-model-item label="封面" prop="imgPath">
        <div class="a-input">
          <simple-uploader v-model="form.data.imgPath"/>
        </div>
      </a-form-model-item>
      <!-- <a-form-model-item label="视频" v-if="form.data.type==='VIDEO'" prop="videoPath">
        <span class="help-tip" slot="extra" style="cursor: pointer" @click="reviewVideo">预览</span>
        <div class="a-input">
          <simple-uploader v-model="form.data.videoPath" :type="form.data.type"/>
        </div>
      </a-form-model-item> -->
      <a-form-model-item>
        <a-space>
          <a-button type="primary" v-if="!indexPosterId" @click="onAdd">创建</a-button>
          <a-button type="primary" v-if="indexPosterId" @click="onUpdate">更新</a-button>
          <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
    <a-modal
        :footer="null"
             append-to-body
             title="视频预览"
             v-model="video.visible">
      <video
        v-if="video.visible"
        ref="video"
        webkit-playsinline="true"
        playsinline="true"
        x-webkit-airplay="true"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
        x5-video-orientation="portraint"
        style="width: 100%;height: auto"
        autoplay
        preload="auto"
        muted="true"
        :src="form.data.videoPath"
      >您的浏览器不支持HTML5
      </video>
    </a-modal>
  </div>
</template>

<script>
import {
  _queryIndexPoster,
  _addIndexPoster,
  _updateIndexPoster,
} from '@/api/indexImagesApi';
// import DictSelect from '@/components/DictSelect.vue';
import SimpleUploader from '@/components/SimpleUploader.vue';

async function getIndexPoster() {
  const result = await _queryIndexPoster(this.indexPosterId);
  if (result) {
    this.form.data.title = result.title;
    this.form.data.subTitle = result.subTitle;
    // this.form.data.type = result.type;
    this.form.data.imgPath = result.imgPath;
    // this.form.data.videoPath = result.videoPath;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addIndexPoster({
        title: this.form.data.title,
        subTitle: this.form.data.subTitle,
        // type: this.form.data.type,
        imgPath: this.form.data.imgPath,
        // videoPath: this.form.data.videoPath,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('添加成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateIndexPoster(this.indexPosterId, {
        title: this.form.data.title,
        subTitle: this.form.data.subTitle,
        // type: this.form.data.type,
        imgPath: this.form.data.imgPath,
        // videoPath: this.form.data.videoPath,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('更新成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

function reviewVideo() {
  if (this.form.data.videoPath) {
    this.video.visible = true;
  }
}

export default {
  name: 'IndexImagesEdit',
  components: {
    SimpleUploader,
    // DictSelect,
  },
  props: {
    indexPosterId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    indexPosterId() {
      if (this.indexPosterId) {
        this.getIndexPoster();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getIndexPoster,
    reviewVideo,
  },
  data() {
    return {
      video: {
        visible: false,
        url: '',
      },
      form: {
        data: {
          title: '',
          subTitle: '',
          imgPath: '',
          type: 'JPG',
        //   videoPath: '',
        },
        rules: {
          title: [{ required: true, trigger: 'blur' }],
          subTitle: [{ required: true, trigger: 'blur' }],
        //   type: [{ required: true, trigger: 'blur' }],
        },
        title: '',
      },
    };
  },
  created() {
    if (this.indexPosterId) {
      this.getIndexPoster();
    }
  },
};
</script>
